import React from "react";
import PropTypes from "prop-types";
// --- Import images
import { ReactComponent as Spiner } from "../../../assets/images/spiner.svg";

import style from "./Preloader.module.sass";

function Preloader({ height, width, color, thickness, className }) {
  // height - parent value
  // width - preloader value
  return (
    <div
      className={`${style.preloaderWrapper} ${className}`}
      style={{ height }}
    >
      <Spiner
        style={{ width, stroke: color, strokeWidth: thickness }}
        className={style.preloader}
      />
    </div>
  );
}

Preloader.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  thickness: PropTypes.string,
  className: PropTypes.string,
};
Preloader.defaultProps = {
  width: "60px",
  height: "100%",
  color: "#000",
  thickness: "7px",
  className: "",
};

export default Preloader;
